var companyNameRegex = /^[{\p{L}}{0-9}{!#@$%^&*+=(). -}].{1,60}$/;
export default companyNameRegex;